import { render, staticRenderFns } from "./navigator.vue?vue&type=template&id=7bd65436&scoped=true"
import script from "./navigator.vue?vue&type=script&lang=js"
export * from "./navigator.vue?vue&type=script&lang=js"
import style0 from "./navigator.vue?vue&type=style&index=0&id=7bd65436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd65436",
  null
  
)

export default component.exports